module.exports = __webpack_public_path__ + "static/media/Graphic 2.30662b56.png";